import React, { createContext, useContext, useState } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { useTheme } from '@/context/ThemeContext';

const PortalContext = createContext(null);
export function ArtifactTooltipScope({ containerRef, children }) {
  return <PortalContext.Provider value={containerRef}>{children}</PortalContext.Provider>;
}

export default function ArtifactTooltip({ title, description, shortcut, children }) {
  const containerRef = useContext(PortalContext);
  const { colors } = useTheme();
  const [open, setOpen] = useState(false);
  if (!description) return children;
  return (
    <Tooltip.Provider delayDuration={300}>
      <Tooltip.Root open={open} onOpenChange={setOpen}>
        <Tooltip.Trigger asChild>
          <span style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>{children}</span>
        </Tooltip.Trigger>
        {/* Stay inside the dialog's top layer when the preview is expanded. */}
        <Tooltip.Portal container={containerRef?.current}>
          <Tooltip.Content side="bottom" sideOffset={9} collisionPadding={12} hideWhenDetached className="artifact-help-card" style={{ zIndex: 10001, maxWidth: 264, padding: '12px 14px', borderRadius: 12, border: `1px solid ${colors.border_color_secondary || '#3b3f45'}`, background: colors.solid_color_secondary || '#202329', color: colors.text_color_primary || '#f4f5f7', boxShadow: '0 8px 28px rgba(0,0,0,.24), 0 2px 6px rgba(0,0,0,.12)', font: '13px/1.5 -apple-system, BlinkMacSystemFont, sans-serif' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 4 }}>
              <strong style={{ fontSize: 13, fontWeight: 600 }}>{title}</strong>
              {shortcut && <kbd style={{ marginLeft: 'auto', border: `1px solid ${colors.border_color_secondary || '#555'}`, borderRadius: 5, padding: '1px 5px', fontFamily: 'inherit', fontSize: 11, lineHeight: 1.5, opacity: .8 }}>{shortcut}</kbd>}
            </div>
            <div style={{ color: colors.text_color_secondary || '#c2c6cf' }}>{description}</div>
            <Tooltip.Arrow width={12} height={6} style={{ fill: colors.solid_color_secondary || '#202329' }} />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
